import { Request, Response } from 'express';
import { InjectionToken } from '@angular/core';

export class DeviceInfo {
    public isPhone: boolean;
    public isTablet: boolean;
    public isDesktop: boolean;
    public isMobile: boolean;
    public device: string;
    public userAgent: string;
}

export class MediaStream {
    public type: string;
    public path: string;
    public url: string;
}

export class CarouselRowConfig {
    dim?: boolean; //apply dim effect to unfocused cells
    grow?: boolean; //apply grow effect to focused cell
    showBack?: boolean; //show back-color on media cell details
    showCopy?: boolean; //show copy text in media cell details
    showDetail?: boolean; //show media cell details
    showTags?: boolean; //show media cell tags
    clipTitle?: boolean; //clip media cell title to one line
    wide?: boolean; //extend carousel full width
    center?: boolean; //center focused cell in carousel
    loop?: boolean; //loop carousel
    noLazy?: boolean; //turn off lazy-load on media cell image
    viewSlides?: number; //number of visible slides in carousel
    spacing?: number; //spacing between slides in carousel
    loopAdditionalSlides?: number; //loop additional slides in carousel
    style?: string; //class style to apply to carousel container
    activeSlug: string; //slug for setting the selected cell
    imageType: string; //override default slide image type
    cellStyle: string; //row render style
    clickEnable: boolean; //enable cell click-through
    showLogo:boolean; //enable series logo
}


export class MediaCellConfig {
    size?: string;
    clickEnable:boolean;
    showCopy?: boolean; //= true;
    noLazy?: boolean; //= false;
    showBack?: boolean; //= false;
    showTags?: boolean; //= true;
    showDetail?: boolean; //= true;
    imageType?: string;
    clipTitle?: boolean;
    collapse: boolean;
    showLogo:boolean;
    showTitle:boolean;
    backEffect:boolean;
}

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
export const DEVICE_INFO = new InjectionToken<DeviceInfo>('DEVICE_INFO');
export const NAVIGATION_LINKS = new InjectionToken<Array<Object>>('NAVIGATION_LINKS');
export const APP_SETTINGS = new InjectionToken<Object>('APP_SETTINGS');



// WEBPACK FOOTER //
// ./src/angular-engine/modules/ng-express-engine/tokens.ts